import {
  createCampaignEmployee,
  deleteCampaignEmployee,
  updateCampaignEmployee,
} from '@store/CampaignEmployeeReducer'
import { SBRM, SBRMForm } from '@supplement-bacon/sbrm-react'
import { useAppDispatch, useAppSelector } from '@utils/hooks'
import { forwardRef } from 'react'
import Create from './Create'
import Delete from './Delete'
import Update from './Update'

const Form: SBRMForm = forwardRef(({ formProps }, ref) => {
  const dispatch = useAppDispatch()
  const { error } = useAppSelector((state) => state.campaignEmployee)

  return (
    <SBRM.BaseEntityForm
      {...{ ref, formProps }}
      error={error && String(error)}
      formActions={{
        create: Create,
        update: Update,
        delete: Delete,
      }}
      handlers={{
        create: async (values) =>
          dispatch(createCampaignEmployee(values)).then(() => {
            return true
          }),
        update: async (values) =>
          dispatch(updateCampaignEmployee(values)).then(() => {
            return true
          }),
        delete: async (values) =>
          dispatch(deleteCampaignEmployee(values)).then(() => {
            return true
          }),
      }}
    />
  )
})

Form.displayName = 'Form'

type FormType = { Form: typeof Form }

export { Form, type FormType }
